// TODO パブリックリリース時は日本時間基準であることを前提とする。将来的に国際化対応を行う。
const jstTimezoneOffset = -9 * 60
export const timezoneOffset = jstTimezoneOffset * 60 * 1000
